import { useStore } from 'effector-react/ssr';

import { Lens } from 'monocle-ts';

import { rootDomain } from '@stores/root';

import { applyLensPayload } from '@utils/lens';

// --- Types ---

export type HeaderState = {
    height: number;
    isOpenCatalogMenu: boolean;
};

// --- Constants ---

export const headerHeightLens = Lens.fromProp<HeaderState>()('height');
export const isOpenCatalogMenuLens = Lens.fromProp<HeaderState>()('isOpenCatalogMenu');

export const headerInitialState: HeaderState = {
    height: 0,
    isOpenCatalogMenu: false,
};

// --- Domain ---

const headerDomain = rootDomain.createDomain();

// --- Events ---

export const setHeight = headerDomain.createEvent<HeaderState['height']>();
export const setIsOpenCatalogMenu = headerDomain.createEvent<HeaderState['isOpenCatalogMenu']>();

// --- Stores ---

const $header = headerDomain
    .createStore<HeaderState>(headerInitialState, { name: 'header' })
    .on(setHeight, applyLensPayload(headerHeightLens))
    .on(setIsOpenCatalogMenu, applyLensPayload(isOpenCatalogMenuLens));

// --- Hooks ---

export const useHeaderStore = (): HeaderState => useStore($header);
